import styles from "./rolesPermissions.module.css";

const PermissionSwitch = ({ checked, disabled, onToggle, label, small = false }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={onToggle}
    className={`${styles.switch} ${small ? styles.switchSmall : ""} ${checked ? styles.switchOn : ""}`}
  >
    <span className={styles.switchKnob} />
  </button>
);

export default PermissionSwitch;
